"use client";

import React from "react";
import {
  Row,
  Col,
  Button,
  Divider,
  Spin,
  Card,
  Form,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Collapse,
  Icon,
} from "antd";
import moment from "moment";
import api from "../../../services/api";
import OptionsService from "../../../services/OptionsService";

class Report extends React.Component {
  state = {
    loading: false,
    filters: {
      // Acordo
      status_acordo: null,
      tipo_acordo: null,
      tipo_cobranca: null,
      operador_username: null,
      data_acordo_ini: null,
      data_acordo_fim: null,
      numero_cliente: null,
      numero_processo: null,
      dias_em_atraso_min: null,
      dias_em_atraso_max: null,
      valor_acordo_min: null,
      valor_acordo_max: null,
      // Pasta/Cliente
      pasta_pasta: null,
      pasta_cpf_cnpj: null,
      pasta_cooperado: null,
      pasta_cooperado_search: null,
      pasta_agencia: null,
      pasta_singular: null,
    },
    // Opções dinâmicas
    agenciaOptions: [],
    cooperadoOptions: [],
    singularOptions: [],
    tipoCobrancaOptions: [],
    tipoAcordoOptions: [],
    operadorOptions: [],
    loadingOptions: {
      agencia: false,
      cooperado: false,
      singular: false,
      tipoCobranca: false,
      tipoAcordo: false,
      operador: false,
    },
  };

  componentDidMount() {
    this.fetchTipoCobrancaOptions("");
    this.fetchTipoAcordoOptions("");
  }

  onFilterChange = (fieldName, value) => {
    this.setState(function (prevState) {
      return {
        filters: {
          ...prevState.filters,
          [fieldName]: value,
        },
      };
    });
  };

  onDateRangeChange = (startField, endField, dates) => {
    if (!dates || dates.length === 0) {
      this.setState(function (prevState) {
        return {
          filters: {
            ...prevState.filters,
            [startField]: null,
            [endField]: null,
          },
        };
      });
      return;
    }

    const start = dates[0] ? dates[0].format("YYYY-MM-DD") : null;
    const end = dates[1] ? dates[1].format("YYYY-MM-DD") : null;

    this.setState(function (prevState) {
      return {
        filters: {
          ...prevState.filters,
          [startField]: start,
          [endField]: end,
        },
      };
    });
  };

  fetchOptions = async (optionType, serviceMethod, query) => {
    const q = typeof query === "string" ? query : "";
    this.setState(function (prevState) {
      return {
        loadingOptions: {
          ...prevState.loadingOptions,
          [optionType]: true,
        },
      };
    });

    try {
      const response = await serviceMethod(q);
      const data = response && response.data ? response.data : [];
      this.setState(function () {
        return {
          [optionType + "Options"]: data,
        };
      });
    } catch (error) {
      console.error("Error fetching " + optionType + " options:", error);
    } finally {
      this.setState(function (prevState) {
        return {
          loadingOptions: {
            ...prevState.loadingOptions,
            [optionType]: false,
          },
        };
      });
    }
  };

  fetchTipoCobrancaOptions = (query) => {
    return this.fetchOptions(
      "tipoCobranca",
      OptionsService.getTipoCobrancaOptions,
      query
    );
  };

  fetchTipoAcordoOptions = (query) => {
    return this.fetchOptions(
      "tipoAcordo",
      OptionsService.getTipoAcordoOptions,
      query
    );
  };

  fetchAgenciaOptions = (query) => {
    return this.fetchOptions(
      "agencia",
      OptionsService.getAgenciaOptions,
      query
    );
  };

  fetchCooperadoOptions = (query) => {
    return this.fetchOptions(
      "cooperado",
      OptionsService.getCooperadoOptions,
      query
    );
  };

  fetchSingularOptions = (query) => {
    return this.fetchOptions(
      "singular",
      OptionsService.getSingularOptions,
      query
    );
  };

  fetchOperadorOptions = (query) => {
    return this.fetchOptions(
      "operador",
      OptionsService.getOperadorOptions,
      query
    );
  };

  appendParam = (params, key, value) => {
    if (value === null || value === undefined || value === "") {
      return;
    }
    params.push(key + "=" + encodeURIComponent(value));
  };

  buildQueryString = () => {
    const { filters } = this.state;
    const params = [];
    const append = this.appendParam;

    // Acordo
    append(params, "status_acordo", filters.status_acordo);
    append(params, "tipo_acordo", filters.tipo_acordo);
    append(params, "tipo_cobranca", filters.tipo_cobranca);
    append(params, "operador__username", filters.operador_username);
    append(params, "data_acordo__gte", filters.data_acordo_ini);
    append(params, "data_acordo__lte", filters.data_acordo_fim);
    append(params, "numero_cliente", filters.numero_cliente);
    append(params, "numero_processo", filters.numero_processo);
    append(params, "dias_em_atraso__gte", filters.dias_em_atraso_min);
    append(params, "dias_em_atraso__lte", filters.dias_em_atraso_max);
    append(params, "valor_acordo__gte", filters.valor_acordo_min);
    append(params, "valor_acordo__lte", filters.valor_acordo_max);

    // Pasta/Cliente
    append(params, "pasta__pasta", filters.pasta_pasta);
    append(params, "pasta__cpf_cnpj", filters.pasta_cpf_cnpj);
    append(params, "pasta__cooperado", filters.pasta_cooperado);
    append(params, "pasta__cooperado__icontains", filters.pasta_cooperado_search);
    append(params, "pasta__agencia", filters.pasta_agencia);
    append(params, "pasta__singular", filters.pasta_singular);

    return params.length > 0 ? "?" + params.join("&") : "";
  };

  clearFilters = () => {
    this.setState({
      filters: {
        status_acordo: null,
        tipo_acordo: null,
        tipo_cobranca: null,
        operador_username: null,
        data_acordo_ini: null,
        data_acordo_fim: null,
        numero_cliente: null,
        numero_processo: null,
        dias_em_atraso_min: null,
        dias_em_atraso_max: null,
        valor_acordo_min: null,
        valor_acordo_max: null,
        pasta_pasta: null,
        pasta_cpf_cnpj: null,
        pasta_cooperado: null,
        pasta_cooperado_search: null,
        pasta_agencia: null,
        pasta_singular: null,
      },
    });
  };

  getActiveFiltersCount = () => {
    const { filters } = this.state;
    return Object.keys(filters).filter(function (key) {
      const value = filters[key];
      return value !== null && value !== undefined && value !== "";
    }).length;
  };

  handleGenerateReport = async () => {
    this.setState({
      loading: true,
    });

    try {
      const queryString = this.buildQueryString();
      const res = await api.get("acordo/acordo_report/" + queryString);

      if (res && res.data && res.data.link) {
        window.open(res.data.link, "_blank");
      }
    } catch (error) {
      console.error("Erro ao gerar relatório:", error);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  formatCurrency = (value) => {
    if (value === undefined || value === null || value === "") {
      return "";
    }
    const str = String(value);
    return "R$ " + str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  parseCurrency = (value) => {
    if (typeof value !== "string") {
      return 0;
    }
    const numeric = value.replace(/\D/g, "");
    if (!numeric) {
      return 0;
    }
    return Number.parseFloat(numeric) / 100;
  };

  renderAcordoFilters = () => {
    const {
      filters,
      tipoAcordoOptions,
      tipoCobrancaOptions,
      operadorOptions,
      loadingOptions,
    } = this.state;

    return (
      <div className="filter-section">
        <h3 className="filter-section-title">Filtros de Acordo</h3>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Status do Acordo</label>
              <Select
                placeholder="Selecione..."
                value={filters.status_acordo}
                onChange={(value) =>
                  this.onFilterChange("status_acordo", value)
                }
                allowClear
              >
                <Select.Option value="ATIVO">Ativo</Select.Option>
                <Select.Option value="Cancelado">Cancelado</Select.Option>
                <Select.Option value="Quitado">Quitado</Select.Option>
                <Select.Option value="Quebrado">Quebrado</Select.Option>
                <Select.Option value="Quebrado - Não pagamento">Quebrado - Não pagamento</Select.Option>
                <Select.Option value="Reacordo">Reacordo</Select.Option>
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Tipo de Acordo</label>
              <Select
                showSearch
                placeholder="Selecione..."
                value={filters.tipo_acordo}
                onChange={(value) =>
                  this.onFilterChange("tipo_acordo", value)
                }
                onSearch={this.fetchTipoAcordoOptions}
                onFocus={() => {
                  if (!tipoAcordoOptions || tipoAcordoOptions.length === 0) {
                    this.fetchTipoAcordoOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.tipoAcordo ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {tipoAcordoOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Tipo de Cobrança</label>
              <Select
                showSearch
                placeholder="Selecione..."
                value={filters.tipo_cobranca}
                onChange={(value) =>
                  this.onFilterChange("tipo_cobranca", value)
                }
                onSearch={this.fetchTipoCobrancaOptions}
                onFocus={() => {
                  if (
                    !tipoCobrancaOptions ||
                    tipoCobrancaOptions.length === 0
                  ) {
                    this.fetchTipoCobrancaOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.tipoCobranca ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {tipoCobrancaOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Operador</label>
              <Select
                showSearch
                placeholder="Digite o nome de usuário"
                value={filters.operador_username}
                onChange={(value) =>
                  this.onFilterChange("operador_username", value)
                }
                onSearch={this.fetchOperadorOptions}
                onFocus={() => {
                  if (!operadorOptions || operadorOptions.length === 0) {
                    this.fetchOperadorOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.operador ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {operadorOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Número do Cliente</label>
              <Input
                placeholder="Ex: 12345"
                value={filters.numero_cliente || ""}
                onChange={(e) =>
                  this.onFilterChange("numero_cliente", e.target.value)
                }
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Número do Processo</label>
              <Input
                placeholder="Ex: 0001234567890"
                value={filters.numero_processo || ""}
                onChange={(e) =>
                  this.onFilterChange("numero_processo", e.target.value)
                }
              />
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Período do Acordo</label>
              <DatePicker.RangePicker
                format="DD/MM/YYYY"
                placeholder={["Data Inicial", "Data Final"]}
                value={
                  filters.data_acordo_ini && filters.data_acordo_fim
                    ? [
                        moment(filters.data_acordo_ini),
                        moment(filters.data_acordo_fim),
                      ]
                    : undefined
                }
                onChange={(dates) =>
                  this.onDateRangeChange(
                    "data_acordo_ini",
                    "data_acordo_fim",
                    dates
                  )
                }
                style={{ width: "100%" }}
              />
            </div>
          </Col>
        </Row>
        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Dias em Atraso (De - Até)</label>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Mín"
                  value={filters.dias_em_atraso_min}
                  onChange={(value) =>
                    this.onFilterChange("dias_em_atraso_min", value)
                  }
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <div className="filter-group" style={{ marginTop: "25px" }}>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Máx"
                  value={filters.dias_em_atraso_max}
                  onChange={(value) =>
                    this.onFilterChange("dias_em_atraso_max", value)
                  }
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={12}>
            <div className="filter-group">
              <label className="filter-label">Valor do Acordo (De - Até)</label>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Mín"
                  value={filters.valor_acordo_min}
                  onChange={(value) =>
                    this.onFilterChange("valor_acordo_min", value)
                  }
                  step={0.01}
                  precision={2}
                  formatter={this.formatCurrency}
                  parser={this.parseCurrency}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <div className="filter-group" style={{ marginTop: "25px" }}>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Máx"
                  value={filters.valor_acordo_max}
                  onChange={(value) =>
                    this.onFilterChange("valor_acordo_max", value)
                  }
                  step={0.01}
                  precision={2}
                  formatter={this.formatCurrency}
                  parser={this.parseCurrency}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderClienteFilters = () => {
    const {
      filters,
      agenciaOptions,
      cooperadoOptions,
      singularOptions,
      loadingOptions,
    } = this.state;

    return (
      <div className="filter-section">
        <h3 className="filter-section-title">Filtros de Pasta/Cliente</h3>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Pasta</label>
              <Input
                placeholder="Digite o nome da pasta"
                value={filters.pasta_pasta || ""}
                onChange={(e) =>
                  this.onFilterChange("pasta_pasta", e.target.value)
                }
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">CPF/CNPJ</label>
              <Input
                placeholder="Ex: 12345678900000"
                value={filters.pasta_cpf_cnpj || ""}
                onChange={(e) =>
                  this.onFilterChange("pasta_cpf_cnpj", e.target.value)
                }
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Agência</label>
              <Select
                showSearch
                placeholder="Ex: 0001"
                value={filters.pasta_agencia}
                onChange={(value) =>
                  this.onFilterChange("pasta_agencia", value)
                }
                onSearch={this.fetchAgenciaOptions}
                onFocus={() => {
                  if (!agenciaOptions || agenciaOptions.length === 0) {
                    this.fetchAgenciaOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.agencia ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {agenciaOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Cooperado</label>
              <Select
                showSearch
                placeholder="Digite o nome do cooperado"
                value={filters.pasta_cooperado}
                onChange={(value) =>
                  this.onFilterChange("pasta_cooperado", value)
                }
                onSearch={this.fetchCooperadoOptions}
                onFocus={() => {
                  if (!cooperadoOptions || cooperadoOptions.length === 0) {
                    this.fetchCooperadoOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.cooperado ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {cooperadoOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Cooperado (Busca Parcial)</label>
              <Input
                placeholder="Busca por parte do nome"
                value={filters.pasta_cooperado_search || ""}
                onChange={(e) =>
                  this.onFilterChange(
                    "pasta_cooperado_search",
                    e.target.value
                  )
                }
              />
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Singular</label>
              <Select
                showSearch
                placeholder="Digite o valor singular"
                value={filters.pasta_singular}
                onChange={(value) =>
                  this.onFilterChange("pasta_singular", value)
                }
                onSearch={this.fetchSingularOptions}
                onFocus={() => {
                  if (!singularOptions || singularOptions.length === 0) {
                    this.fetchSingularOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.singular ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {singularOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    const { loading } = this.state;
    const activeFiltersCount = this.getActiveFiltersCount();

    if (loading) {
      return (
        <div className="report-loading-container">
          <Spin size="large" tip="Gerando relatório de Acordo..." />
        </div>
      );
    }

    return (
      <div className="report-container">
        <Card className="report-card">
          <div className="report-header">
            <h1 className="report-title">Relatório de Acordos</h1>
            <p className="report-description">
              Configure os filtros desejados para gerar relatórios precisos e
              detalhados
            </p>
          </div>

          <Divider />

          <div className="filters-info">
            {activeFiltersCount > 0 ? (
              <div className="active-filters-badge">
                <Icon type="filter" />
                <span>{activeFiltersCount} filtro(s) ativo(s)</span>
              </div>
            ) : null}
          </div>

          <Collapse accordion={false} className="filters-collapse">
            <Collapse.Panel
              header={
                <span className="collapse-header">
                  <Icon type="file-text" /> Filtros de Acordo
                </span>
              }
              key="1"
            >
              {this.renderAcordoFilters()}
            </Collapse.Panel>

            <Collapse.Panel
              header={
                <span className="collapse-header">
                  <Icon type="file-text" /> Filtros de Pasta/Cliente
                </span>
              }
              key="2"
            >
              {this.renderClienteFilters()}
            </Collapse.Panel>
          </Collapse>

          <Divider style={{ margin: "24px 0" }} />

          <div className="action-buttons">
            <Button
              type="default"
              onClick={this.clearFilters}
              style={{ marginRight: "8px" }}
              icon="delete"
            >
              Limpar Filtros
            </Button>

            <Button
              type="primary"
              onClick={this.handleGenerateReport}
              icon="file-excel"
              size="large"
            >
              Gerar Relatório
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

export const ReportForm = Form.create({ name: "report_acordo" })(Report);



// WEBPACK FOOTER //
// ./src/pages/Relatorios/Acordo/component.js